import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as ArrowBackIcon } from "assets/images/common/svgs/arrow_back.svg";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";
import useProductItem from "containers/master-portal/useHooks";
import useUtils from "hooks/useUtils";
import { useSelector } from "react-redux";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";

type FormValues = {
  shippingCompany: string;
  consigneeNumber: string;
};

const ViewOrderRequest: React.FC = () => {
  const navigate = useNavigate();
  const [data, setData] = useState<any>({});
  const { getOrderProductById, createConsigneinfo } = useProductItem();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const location = useLocation();
  const { orderRequest } = location.state || {};

  console.log(orderRequest);

  const columns: string[] = [
    "Sr No.",
    "Item Image",
    "Item Name",
    "Item Quanity",
    "Delivery",
    "Price points",
  ];

  // Initialize react-hook-form
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<FormValues>();

  const onSubmit = (data: FormValues) => {
    createConsigneinfo(data, { productRequestId: orderRequest?.id });
    reset();
  };

  useEffect(() => {
    getOrderProductById({ orderId: orderRequest?.id }, setData);
  }, []);

  console.log(data);

  const handleBack = () => {
    navigate(-1);
  };

  const arrr = [1, 2, 3];
  const arrr2 = [1, 2, 3, 4];
  const arrr3 = [
    {
      value: 1,
    },
    {
      value: 2,
    },
  ];

  function calculte(acc, item) {
    return acc + item;
  }

  console.log(arrr.reduce(calculte, 0));
  console.log(
    arrr3.reduce((acc, item) => {
      return calculte(acc, item.value);
    }, 0)
  );

  return (
    <div>
      <h1 className="text-base text-primaryText font-bold mb-6 flex items-center gap-3">
        <span
          onClick={handleBack}
          className="bg-transparentBlueBg w-[44px] h-[44px] rounded-full flex items-center justify-center cursor-pointer"
        >
          <ArrowBackIcon />
        </span>
        Order Request Details
      </h1>

      <div className="w-full bg-white p-4 rounded-[8px]">
        <div className="flex justify-between gap-6 items-center">
          <h1 className="text-primaryText text-2xl font-bold">INVOICE</h1>
          <h1 className="text-primaryText text-2xl font-bold capitalize">
            {orderRequest?.deliveryStatus || "--"}
          </h1>
        </div>
        <div className="flex justify-between mt-4">
          <div className="flex flex-col gap-2">
            <span className="text-sm font-bold text-primaryText">
              Ambassador Name
            </span>
            <span className="flex items-center gap-2">
              <img
                className="w-[52px] h-[52px] rounded-full"
                src={
                  orderRequest?.ambassador?.user?.profilePic
                    ? concatPathWithBackendUrl(
                        orderRequest?.ambassador?.user?.profilePic?.name
                      )
                    : editProfilePicUser
                }
                alt="Ambassador"
              />
              <h1 className="text-sm text-darkSlateBlueText">
                <h1 className="text-sm text-darkSlateBlueText">
                  {(orderRequest?.ambassador?.user?.firstName || "--") +
                    " " +
                    (orderRequest?.ambassador?.user?.lastName || "--")}
                </h1>
              </h1>
            </span>
          </div>
          <div className="flex flex-col gap-4">
            <span className="text-sm font-bold text-primaryText">Address</span>
            <span className="text-sm text-darkSlateBlueText ">
              {orderRequest?.deliveryAddress || "--"}
            </span>
          </div>
          <div className="flex flex-col gap-4">
            <span className="text-sm font-bold text-primaryText">
              Date & Time
            </span>
            <span className="text-sm text-darkSlateBlueText">
              {orderRequest?.createdAt
                ? new Date(orderRequest.createdAt)
                    .toLocaleString("en-US", {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                      hour: "numeric",
                      minute: "numeric",
                      hour12: true,
                    })
                    .replace(",", " -")
                : "N/A"}
            </span>
          </div>
        </div>
        <div>
          <table className="min-w-full mt-8">
            <thead className="bg-white">
              <tr className="text-left border-t border-dividerGray">
                {columns.map((column, index) => (
                  <th
                    className="px-4 py-4 text-sm font-bold text-left text-primaryText whitespace-nowrap"
                    key={index}
                  >
                    {column}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white">
              {data?.productDetails?.map((item: any, index: number) => (
                <tr key={index} className=" border-b border-dividerGray">
                  <td className="px-4 py-4 text-sm  text-primaryText font-semibold whitespace-nowrap">
                    {index + 1}
                  </td>
                  <td className="px-4 py-4">
                    <img
                      className="rounded-full w-9 h-9 object-cover"
                      src={
                        item?.product?.image
                          ? concatPathWithBackendUrl(item?.product?.image.name)
                          : editProfilePicUser
                      }
                      alt="Item"
                    />
                  </td>
                  <td className="px-4 py-4 text-sm  text-primaryText font-semibold whitespace-nowrap">
                    {item?.product?.itemName}
                  </td>
                  <td className="px-4 py-4 text-sm  text-primaryText font-semibold whitespace-nowrap">
                    {item?.itemQuantity}
                  </td>
                  <td className="px-4 py-4 text-sm  text-primaryText font-semibold whitespace-nowrap">
                    {item?.product?.deliveryFee}
                  </td>
                  <td className="px-4 py-4 text-sm  text-primaryText font-semibold whitespace-nowrap">
                    {item?.itemTotal}
                    {""}pts
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="flex justify-end mt-4">
            <span className="flex flex-col items-center gap-2">
              <p className="text-captionText font-semibold text-sm">
                Sub Total
              </p>
              <p className="text-darkSlateBlueText font-bold text-lg">
                {data?.productDetails?.reduce(
                  (acc: number, item: any) => acc + (item?.itemTotal || 0),
                  0
                ) +
                  data?.productDetails?.reduce(
                    (acc: number, item: any) =>
                      acc + (item?.product.deliveryFee || 0),
                    0
                  )}
              </p>
            </span>
          </div>
        </div>

        {/*  */}
        {orderRequest?.deliveryStatus !== "dispatched" && (
          <div>
            <p className="text-labelText font-semibold text-base">
              Notify with Details
            </p>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                <div className="flex flex-col gap-2">
                  <label className="text-labelText">Shipping Company</label>
                  <input
                    type="text"
                    placeholder="Shipping Company"
                    {...register("shippingCompany", {
                      required: "Shipping Company is required",
                      maxLength: {
                        value: 50,
                        message: "Max length is 50 characters",
                      },
                    })}
                    className={`w-full h-[51px] px-4 border rounded-lg outline-none ${
                      errors.shippingCompany
                        ? "border-red-500"
                        : "border-gray-300"
                    }`}
                  />
                  {errors.shippingCompany && (
                    <span className="text-red-500 text-sm">
                      {errors.shippingCompany.message}
                    </span>
                  )}
                </div>

                <div className="flex flex-col gap-2">
                  <label className="text-labelText">Consignee Number</label>
                  <input
                    type="text"
                    placeholder="Consignee Number"
                    {...register("consigneeNumber", {
                      required: "Consignee Number is required",
                      pattern: {
                        value: /^[0-9]+$/,
                        message: "Only numeric characters allowed",
                      },
                    })}
                    className={`w-full h-[51px] px-4 border rounded-lg outline-none ${
                      errors.consigneeNumber
                        ? "border-red-500"
                        : "border-gray-300"
                    }`}
                  />
                  {errors.consigneeNumber && (
                    <span className="text-red-500 text-sm">
                      {errors.consigneeNumber.message}
                    </span>
                  )}
                </div>
              </div>

              <button
                type="submit"
                className="bg-greenBg text-white text-sm px-6 py-2 rounded-lg mt-6"
              >
                Send
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewOrderRequest;
